import Image from '@tiptap/extension-image'

/**
 * The default Image extension extended to persist a stable `s3Key` attribute
 * alongside `src`, so the API can re-sign the image URL on every read.
 */
export const ImageWithKey = Image.extend({
  name: 'image',

  addAttributes() {
    return {
      ...this.parent?.(),
      s3Key: { default: null },
    }
  },
}).configure({
  inline: false,
  HTMLAttributes: {
    style: 'max-width:100%;border-radius:8px;display:block;margin:12px 0;',
  },
})
